<template>
  <div>
    <div
      v-for="(data, idx) in value"
      :key="`row-${idx}`"
      class="match-group"
    >
      <b-col cols="12">
        <div class="d-flex justify-content-between align-items-center">
          <h4>
            #{{ idx + 1 }}
          </h4>

          <b-button
            variant="danger"
            class="mt-1"
            @click="remove(idx)"
          >
            <feather-icon icon="TrashIcon" />
          </b-button>
        </div>
      </b-col>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              :vid="`name-${idx}`"
              :name="$t('field.name')"
              rules="required"
            >
              <label>
                {{ $t('field.name') }}
              </label>
              <b-form-input
                :id="`name-${idx}`"
                v-model="data.bankName"
                :name="`name-${idx}`"
                buttons
                button-variant="outline-primary"
                :disabled="readonly"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="6">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              :vid="`logo-${idx}`"
              :name="$t('field.logo')"
              :rules="data.logoUrl ? '' : 'required'"
            >
              <label>
                {{ $t('field.logo') }}
              </label>
              <n-single-image-uploader
                v-model="data.logo"
                :vid="`logo-${idx}`"
                :pw="200"
                :ph="200"
                :full-width="false"
                :image="data.logoUrl"
                :readonly="readonly"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group>
            <validation-provider
              #default="{ errors }"
              :vid="`qrCode-${idx}`"
              :name="$t('field.qrCode')"
              :rules="data.qrCodeUrl ? '' : 'required'"
            >
              <label>
                {{ $t('field.qrCode') }}
              </label>
              <n-single-image-uploader
                v-model="data.qrCode"
                :vid="`qrCode-${idx}`"
                :pw="200"
                :ph="200"
                :full-width="false"
                :image="data.qrCodeUrl"
                :readonly="readonly"
                :class="errors.length > 0 ? 'is-invalid' : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
    <b-row v-if="!readonly">
      <b-col md="6">
        <b-button
          variant="danger"
          block
          class="mt-1"
          @click="remove(-1)"
        >
          {{ $t('button.remove') }} {{ $t('field.bank') }}
        </b-button>
      </b-col>
      <b-col md="6">
        <b-button
          variant="primary"
          block
          class="mt-1"
          @click="add()"
        >
          {{ $t('button.add') }} {{ $t('field.bank') }}
        </b-button>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
} from 'bootstrap-vue'
import NSingleImageUploader from '@/components/NSingleImageUploader.vue'

export default {
  components: {
    NSingleImageUploader,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
  },
  props: {
    value: {
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    remove(idx) {
      const banks = [...this.value]
      banks.splice(idx === -1 ? banks.length - 1 : idx, 1)
      this.$emit('input', banks)
    },
    add() {
      const banks = [...this.value]
      banks.push({
        no: banks.length + 1,
        bankName: null,
        logo: null,
        qrCode: null,
      })
      this.$emit('input', banks)
    },
  },
  setup() {
  },
}
</script>
